import { UrlForm } from '@/components/UrlForm';
import { NEVERZERO_PRICE_LABEL } from '@/lib/pricing';
import { useT } from '@/lib/useLang';

/**
 * Le prix en clair, pour le visiteur qui compare avant de lire le reste. Le
 * formulaire est répété ici : quelqu'un qui arrive au prix et le trouve juste
 * ne doit pas avoir à remonter au hero.
 */
export function Pricing() {
  const t = useT();

  return (
    <section id="pricing" className="nz-section">
      <div className="nz-pricing__card">
        <div className="nz-eyebrow">{t.pricingEyebrow}</div>
        <h2 className="nz-h2">{t.pricingH2}</h2>
        <div>
          <span className="nz-pricing__price">{NEVERZERO_PRICE_LABEL}</span>
          <span className="nz-pricing__per">{t.pricingPer}</span>
        </div>
        <ul className="nz-pricing__list">
          {t.pricingItems.map((item) => (
            <li key={item}>
              <span className="nz-trust__check" aria-hidden="true">
                ✓
              </span>
              {item}
            </li>
          ))}
        </ul>
        <p className="nz-pricing__math">{t.pricingMath}</p>
        <UrlForm id="pricing-linkedin-url" />
      </div>
    </section>
  );
}
